// types
import { ReportColumnDto } from 'src/api';
// @mui
import { isAutogeneratedRow } from '@mui/x-data-grid-premium';
// constants
import { singleSelectAggregationModels } from '../constants/aggregation-model/single-select';

export function StartMembershipStatusColumn(index: number) {
  const column = {
    field: 'startMembershipStatus',
    headerName: 'Start membership status',
    description: 'Membership status at the start of period Column',
    type: 'singleSelect',
    valueOptions: ['Active', 'Cancelled', 'On hold', 'Inactive'],
    index,
    width: 200,
    groupable: true,
    availableAggregationFunctions: singleSelectAggregationModels,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (value: any) => {
      if (value && value.status && value.name) {
        return value.name;
      }
      return value;
    },
    renderCell: (params: any) => {
      if (isAutogeneratedRow(params.row)) {
        return params.value;
      }
      if (params.value && params.value.status && params.value.name) {
        return params.value.name;
      }
      return params.value;
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}
